module.exports = __webpack_public_path__ + "static/media/design.78e819b1.svg";